import Alert from './alert'
import Badge from './badge'
import Button from './button'
import Tag from './tag'
import Input from './input'
import Checkbox from './checkbox'
import Radio from './radio'
import Table from './table'
import Link from './link'
import Tabs from './tabs'
import Switch from './switch'
import Slider from './slider'

export default {
  Checkbox,
  Radio,
  Alert,
  Tabs,
  Tag,
  Button,
  Badge,
  Input,
  Table,
  Link,
  Switch,
  CloseButton: {
    defaultProps: {
      fontSize: '10px',
    },
  },
  Divider: {
    variants: {
      dark: {
        borderColor: 'grey.500',
        borderStyle: 'solid',
      },
    },
  },
  FormError: {
    baseStyle: {
      text: {
        color: 'mld.alert.700',
        fontFamily: 'body',
        fontSize: 'sm',
        lineHeight: 3,
        fontWeight: 'normal',
        letterSpacing: 4,
      },
    },
  },
  Text: {
    variants: {
      semiBoldSmall: {
        fontWeight: 'semibold',
        fontSize: 'sm',
      },
    },
  },
  Slider,
}
